import { useEffect } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import stylisRTLPlugin from 'stylis-plugin-rtl';

interface RTLProps {
  children: ReactNode;
  direction: 'ltr' | 'rtl';
}

const styleCache = () =>
  createCache({
    key: 'rtl',
    prepend: true,
    // @ts-ignore (temporary workaround)
    stylisPlugins: [stylisRTLPlugin]
  });

const RTL: FC<RTLProps> = (props) => {
  const { children, direction } = props;

  useEffect(() => {
    document.dir = direction;
  }, [direction]);

  if (direction === 'rtl') {
    return <CacheProvider value={styleCache()}>{children}</CacheProvider>;
  }

  return <>{children}</>;
};

RTL.propTypes = {
  children: PropTypes.node.isRequired,
  direction: (props, propName, componentName) => {
    if (props[propName] !== 'ltr' && props[propName] !== 'rtl') {
      return new Error(
        `Invalid prop '${propName}' supplied to '${componentName}'. It should be 'ltr' or 'rtl'.`
      );
    }
    return null;
  }
};

export default RTL;
